"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiPointModel$ = exports.MultiPointModel$outboundSchema = exports.MultiPointModel$inboundSchema = void 0;
exports.multiPointModelToJSON = multiPointModelToJSON;
exports.multiPointModelFromJSON = multiPointModelFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.MultiPointModel$inboundSchema = z.object({
    coordinates: z.array(z.array(z.number())),
    type: z.literal("MultiPoint").default("MultiPoint").optional(),
});
/** @internal */
exports.MultiPointModel$outboundSchema = z.object({
    coordinates: z.array(z.array(z.number())),
    type: z.literal("MultiPoint").default("MultiPoint"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MultiPointModel$;
(function (MultiPointModel$) {
    /** @deprecated use `MultiPointModel$inboundSchema` instead. */
    MultiPointModel$.inboundSchema = exports.MultiPointModel$inboundSchema;
    /** @deprecated use `MultiPointModel$outboundSchema` instead. */
    MultiPointModel$.outboundSchema = exports.MultiPointModel$outboundSchema;
})(MultiPointModel$ || (exports.MultiPointModel$ = MultiPointModel$ = {}));
function multiPointModelToJSON(multiPointModel) {
    return JSON.stringify(exports.MultiPointModel$outboundSchema.parse(multiPointModel));
}
function multiPointModelFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.MultiPointModel$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MultiPointModel' from JSON`);
}
//# sourceMappingURL=multipointmodel.js.map